module.exports = __webpack_public_path__ + "static/img/vrroad_function02.7f53b0c0.png";